import "./init.js";
import "react-app-polyfill/ie9";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import { HashRouter, Route, Switch } from "react-router-dom";
import Main from "./components/main/Main";
import { VideoProvider } from "./store/videoContext";
import { ApolloProvider } from "react-apollo";

import client from "./api/client";
import "../src/translation";
const { LUXDialogProvider } = require("luna-rocket/LUXDialog");

ReactDOM.render(
  <ApolloProvider client={client}>
    <LUXDialogProvider>
      <VideoProvider>
        <HashRouter>
          <Switch>
            <Route path="/:year" component={Main} />
            <Route path="/" component={Main} />
          </Switch>
        </HashRouter>
      </VideoProvider>
    </LUXDialogProvider>
  </ApolloProvider>,
  document.getElementById("root")
);
